import { z } from 'zod';
export const BOOK_EVENT_TYPES = [
    'generation.queued',
    'generation.started',
    'generation.progress',
    'generation.succeeded',
    'generation.failed',
    'export.started',
    'export.succeeded',
    'export.failed',
    'book.status',
];
export const BookEventSchema = z.object({
    id: z.string().uuid(),
    type: z.enum(BOOK_EVENT_TYPES),
    bookId: z.string().uuid(),
    generationId: z.string().uuid().optional(),
    exportId: z.string().uuid().optional(),
    progress: z.number().min(0).max(100).optional(),
    status: z.string().optional(),
    message: z.string().optional(),
    at: z.string().datetime(),
});
export function bookEventChannel(bookId) {
    return `book:${bookId}:events`;
}
//# sourceMappingURL=events.js.map